<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import ButtonGroup from 'dashboard/components-next/buttonGroup/ButtonGroup.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { computed } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';

const { updateUISettings } = useUISettings();

const { uiSettings } = useUISettings();
const isContactSidebarOpen = computed(
  () => uiSettings.value.is_contact_sidebar_open
);

const toggleConversationSidebarToggle = () => {
  updateUISettings({
    is_contact_sidebar_open: !isContactSidebarOpen.value,
    is_copilot_panel_open: false,
  });
};

const keyboardEvents = {
  'Alt+KeyO': {
    action: toggleConversationSidebarToggle,
  },
};
useKeyboardEvents(keyboardEvents);
</script>

<template>
  <ButtonGroup class="flex flex-row items-center gap-1">
    <Button
      v-tooltip.top="$t('CONVERSATION.SIDEBAR.CONTACT')"
      :label="$t('CONVERSATION.SIDEBAR.CONTACT_INFO_BUTTON')"
      :aria-label="$t('CONVERSATION.SIDEBAR.CONTACT_INFO_BUTTON')"
      class="rtl:rounded-l-none !outline-0 !bg-n-blue-9 !text-white hover:enabled:!bg-n-blue-10 inline-flex items-center min-w-0 gap-2 transition-all duration-100 ease-out border-0 rounded-lg outline-1 outline disabled:opacity-50 bg-n-blue-9 text-white hover:enabled:bg-n-blue-10 focus-visible:bg-n-blue-10 outline-transparent h-8 !w-8 !px-0 md:!w-auto md:!px-3 text-sm justify-center !font-normal [&_.button-label]:hidden md:[&_.button-label]:inline"
      icon="i-lucide-contact-round"
      @click="toggleConversationSidebarToggle"
    />
  </ButtonGroup>
</template>
